export const SET_MOBILE_MENU_STATE = 'SET_MOBILE_MENU_STATE';
export const GET_CURRENT_PAGE_TITLE = 'GET_CURRENT_PAGE_TITLE';
export const SET_CURRENT_PAGE_TITLE = 'SET_CURRENT_PAGE_TITLE';
export const GET_APP_STATISTICS = 'GET_APP_STATISTICS';



// WEBPACK FOOTER //
// ./src/data/constants/general-constants.jsx